import React, {Component} from 'react'
import DocumentTitle from "react-document-title"
import {Icon} from 'antd';
import {TabBar, NavBar} from 'antd-mobile';
import Dashboard from "../Dashboard";
import ClaimList from "../ClaimList";
import User from "../User";
import ShoppingCart from "../ShoppingCart";


class Home extends Component {

    static defaultProps = {
        loading: false
    };

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: 'home',
            hidden: false,
            height: document.documentElement.clientHeight - 64,
        };
    }

    onClickLogout = () => {
        localStorage.setItem("urlBack", window.location.href);
        this.props.history.replace('/login');
    };

    handleClick = e => {
        this.setState({current: e.key});
        this.props.history.push('/'+e.key);
    };

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    render() {
        //let hiddenFt = this.props.hasOwnProperty('hiddenFt') && this.props.hiddenFt !== undefined ? this.props.hiddenFt : false;
        return (<DocumentTitle title={this.props.hasOwnProperty('title') && this.props.title !== undefined ? this.props.title : 'InsuNow'}>
                <div className={"main-container"}>
                    <NavBar
                        mode="dark"
                        rightContent={[
                            <Icon key="1" type="bell" />,
                        ]}
                        className='top-nav-bar'
                    >INSUNOW</NavBar>

                    <div className="tabBarBox" style={{height: this.state.height,}}>
                    <TabBar
                        unselectedTintColor="#191919"
                        tintColor="#EA8025"
                        barTintColor="white"
                        tabBarPosition="bottom"
                        hidden={this.state.hidden}
                        prerenderingSiblingsNumber={0}
                    >
                        <TabBar.Item
                            title="Bảo Hiểm"
                            key="home"
                            icon={<Icon type='home'/>}
                            selectedIcon={<Icon type='home'/>}
                            selected={this.state.selectedTab === 'home'}
                            onPress={() => {
                                this.setState({
                                    selectedTab: 'home',
                                });
                            }}
                            data-seed="logId"
                        >
                            <Dashboard {...this.props} />
                        </TabBar.Item>
                        <TabBar.Item
                            icon={<Icon type="shop" />}
                            selectedIcon={<Icon type="shop" />}
                            title="Xe của tôi"
                            key="shopping"
                            selected={this.state.selectedTab === 'shopping'}
                            onPress={() => {
                                this.setState({
                                    selectedTab: 'shopping',
                                });
                            }}
                            data-seed="logId1"
                        >
                            <ShoppingCart {...this.props} />
                        </TabBar.Item>
                        <TabBar.Item
                            icon={<Icon type="question-circle" />}
                            selectedIcon={<Icon type="question-circle" />}
                            title="Bồi thường"
                            key="support"
                            selected={this.state.selectedTab === 'support'}
                            onPress={() => {
                                this.setState({
                                    selectedTab: 'support',
                                });
                            }}
                        >
                            <ClaimList {...this.props} />
                        </TabBar.Item>
                        <TabBar.Item
                            icon={<Icon type="user" />}
                            selectedIcon={<Icon type="user" />}
                            title="Cá nhân"
                            key="user"
                            selected={this.state.selectedTab === 'user'}
                            onPress={() => {
                                this.setState({
                                    selectedTab: 'user',
                                });
                            }}
                        >
                            <User {...this.props} />
                        </TabBar.Item>
                    </TabBar>
                    </div>
                </div>
            </DocumentTitle>
        )
    }
}

export default Home